import React, { useEffect, useState } from "react";
import DataTableBase from "../../common/DateTableBase";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../utility";
import Loader from "../../common/Loader";

const dataa = [
    {
        id:'#q5d9fcf7',
        staff: 'Saff A',
        name: 'Angleria Horgan',
        status: 'Active',
        wallet: 2000,
        date: '18-09-2023',
        time: '18:30',
        transfer: 'QR Code',
    },
    {
        id:'#q5s9sc57',
        staff: 'Saff B',
        name: 'Ethan Hunt',
        status: 'Inactive',
        date: '12-05-2023',
        time: '14:30',
        transfer: 'Bank transfer',
        wallet: 5000
    },
    {
        id:'#qj3d937',
        staff: 'Saff C',
        name: 'The Rock',
        time: '16:23',
        status: 'Pending',
        date: '17-08-2023',
        transfer: 'Credit card',
        wallet: 3000
    },
    {
        id:'#q3d3f0f7',
        staff: 'Saff D',
        name: 'Wyn Johnson',
        status: 'Incomplete',
        date: '11-01-2023',
        time: '19:27',
        transfer: 'Bank transfer',
        wallet: 5000
    },
]

const FundRequest = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("user_token");
        
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/funds`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("Fund request list : ", res);
            setData(res?.data?.data);
            setFilteredData(res?.data?.data);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log("Fund request list error : ", err);
        })

    }, [])

    const handleChange = (e) => {
        const value = e.target.value;
        const filteredArray = data?.filter(item => item?.request_id?.toLowerCase()?.includes(value?.toLowerCase()) || item?.transfer_type?.toLowerCase()?.includes(value?.toLowerCase()) || item?.fund_amount.toString()?.includes(value) || item?.status?.toLowerCase()?.includes(value?.toLowerCase()))
        setFilteredData(filteredArray);
    }

    const columns = [
        {
            name:  <span className="tableHeaderText">No.</span>,
            width: '60px',
            selector: (row, index) => index + 1,
        },      
        {
            name: <span className="tableHeaderText">View</span>,
            width: '100px',
            selector: row => <>
                <button className="btn-title" title="View Detail">
                    <svg className="pointer" onClick={() => navigate(`/fund-requests/detail/${row?.id}`)} xmlns="http://www.w3.org/2000/svg" width="22.771" height="22.771" viewBox="1746.229 438.416 22.771 22.771"><path d="M1756.102 438.444c-5.445 0-9.873 4.429-9.873 9.873 0 5.444 4.428 9.873 9.873 9.873 1.664 0 3.3-.395 4.682-1.157.111.134.234.256.367.367l2.82 2.821a2.877 2.877 0 1 0 4.063-4.062l-2.82-2.82a2.821 2.821 0 0 0-.452-.368c.761-1.382 1.24-2.99 1.24-4.682 0-5.445-4.428-9.873-9.872-9.873Zm0 2.82a7.019 7.019 0 0 1 7.052 7.053c0 1.862-.677 3.582-1.862 4.852l-.085.084c-.133.111-.256.234-.366.367-1.241 1.129-2.934 1.777-4.768 1.777a7.019 7.019 0 0 1-7.052-7.052 7.019 7.019 0 0 1 7.052-7.052Z" fill="#197547" fill-rule="evenodd" data-name="Icon open-magnifying-glass"/></svg>
                </button>
            </>
        },      
        {
            name:  <span className="tableHeaderText">Request ID</span>,
            selector: row => row?.request_id,
        },
        {
            name:  <span className="tableHeaderText">Transfer</span>,
            selector: row => row?.transfer_type,
        },
        {
            name: <span className="tableHeaderText">Status</span>,
            selector: row => <span className={row?.status === 'Success' ? "active-status"
            : row?.status === 'Failed'? "inactive-status" 
            : row?.status === 'Pending' ? "text-warning" 
            : "text-secondary"}>{row?.status}</span>
        },
        {
            name: <span className="tableHeaderText">Fund Request</span>,
            selector: row => (Number(row?.fund_amount)).toLocaleString(),
        },
        {
            name:  <span className="tableHeaderText">Date</span>,
            selector: row => {
                if(row?.created_at){
                    let date = new Date(row?.created_at);
                    let formateDate = date.toISOString()?.split('T')[0];
                    return formateDate;                
                }
            },
        },
        {
            name:  <span className="tableHeaderText">Time</span>,
            selector: row => {
                if(row?.created_at){
                    let date = new Date(row?.created_at);
                    let formateDate = date.toISOString()?.split('T')[1];
                    let time = formateDate?.split('.')[0];
                    return time;
                }
            },
        },
    ];

    return (
        <div className="stafflist-page">
            <h1 className="stafflistHeader mt-3 pb-4">
                Top Up List
            </h1>

            <div className="d-flex justify-content-left mt-4 mb-3" style={{height: '42px'}} >
                <div className="p-relative">
                    <input className="searchBox" placeholder="Search..." type="text" onChange={handleChange} style={{width: '300px'}} />
                    <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="23.062" height="23.062" viewBox="1764.938 75.468 23.062 23.062"><path d="M1774.937 75.497c-5.514 0-10 4.485-10 10 0 5.513 4.486 9.998 10 9.998 1.685 0 3.342-.4 4.742-1.171.112.135.237.26.372.371l2.856 2.857a2.914 2.914 0 1 0 4.114-4.114l-2.857-2.857a2.857 2.857 0 0 0-.457-.371c.772-1.4 1.257-3.028 1.257-4.742 0-5.514-4.485-10-9.999-10Zm0 2.857a7.109 7.109 0 0 1 7.142 7.142c0 1.886-.686 3.628-1.886 4.914l-.085.086c-.135.112-.26.236-.372.371-1.257 1.143-2.97 1.8-4.828 1.8a7.109 7.109 0 0 1-7.142-7.142 7.109 7.109 0 0 1 7.142-7.143Z" fill="#d2d2d2" fill-rule="evenodd" data-name="Icon open-magnifying-glass"/></svg>
                </div>
                <button onClick={() => navigate('/fund-requests/add')} className="pointerButton ms-4">
                        Create Top Up
                        <svg className="ms-2" xmlns="http://www.w3.org/2000/svg" width="20.587" height="20.587" viewBox="838.955 86 20.587 20.587"><path d="M858.071 94.088h-6.617V87.47a1.47 1.47 0 0 0-1.47-1.47h-1.47a1.47 1.47 0 0 0-1.471 1.47v6.618h-6.617a1.47 1.47 0 0 0-1.47 1.47v1.47c0 .813.658 1.471 1.47 1.471h6.617v6.617c0 .812.658 1.47 1.47 1.47h1.47a1.47 1.47 0 0 0 1.471-1.47V98.5h6.617a1.47 1.47 0 0 0 1.47-1.47v-1.47a1.47 1.47 0 0 0-1.47-1.471Z" fill="#fff" fill-rule="evenodd" data-name="Icon awesome-plus"/></svg>
                </button>
            </div>

            <div className="d-flex justify-content-between mt-2">
                {/* <div className="pt-4">
                    <h3 className="stafflist-t2 mb-0">Top Up List</h3>
                </div> */}
                <div>

                </div>
            </div>
            <div className="staff-table-div pt-3">
            {loading ? (
                    <Loader />
                ) : (
                <DataTableBase 
                    columns={columns}
                    data={filteredData}
                    pagination
                />)}
            </div>
        </div>
    )
}

export default FundRequest;